export default function equaTo(value, options = {}) {
  return value !== this.fields[options.field].value;
}

equaTo.message = function message(value, options = {}) {
  return options.message || (options.label ? `precisa ser igual a ${options.label}` : 'precisa ser igual');
};
